import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {NavigationElement} from 'app/shared/model/navigation-element';
import {NavigationView} from 'app/shared/model/navigation-view';
import {NavigationStore} from 'app/shared/store/navigation.store';

@Injectable({
    providedIn: 'root'
})

export class NavigationService {

    private readonly resourceUrl = environment.apiUrl + '/navigation';

    constructor(
        private router: Router,
        private http: HttpClient,
        private navigationStore: NavigationStore,
    ) {
    }

    navigate(element, nextView?: NavigationView): Promise<boolean> {
        if (!nextView) {
            const currentView = this.navigationStore.getCurrentViewSnapshot();
            if (element.typeElement === 'PIECE' && (currentView === NavigationView.DASHBOARD || currentView === NavigationView.ESPACES)) {
                // si on arrive à une pièce depuis la vue "dashboard" ou "données", alors on passe à la vue "ouvrages"
                nextView = NavigationView.OUVRAGES;
            } else if (currentView === NavigationView.OUVRAGES) {
                // si on vient de "liste ouvrages", alors on reste dessus
                nextView = NavigationView.OUVRAGES;
            } else {
                // sinon on conserve la même vue
                nextView = currentView;
            }
        }
        // utilisation du nextView (enum NavigationViews) dans l'url après modification (minuscule + remplacement des '_' par '-')
        return this.router.navigate(['/bim/' + element.typeElement + '/' + element.id + '/', nextView.toLowerCase().replace(/_/g, '-')]);
    }

    findElementNavigation(id: string): Observable<NavigationElement> {
        return this.http.get<NavigationElement>(`${this.resourceUrl}/elements/${id}`);
    }

    queryElements(searchValue: string): Observable<NavigationElement[]> {
        if (searchValue) {
            const params = new HttpParams().set('searchPhrase', searchValue);
            return this.http.get<NavigationElement[]>(`${this.resourceUrl}/elements/query`, {params});
        } else {
            return of([]);
        }
    }

}

